/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Error_DefaultInputs */

const en_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong loading this. It’s us, not you.`)
};

const zh_hans1_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载出错了。是我们的问题，不是你的。`)
};

const pt_br2_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado ao carregar isto. O problema é nosso, não seu.`)
};

const es_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal al cargar esto. Es un problema nuestro, no tuyo.`)
};

const fr_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un problème est survenu au chargement. C’est de notre côté, pas du vôtre.`)
};

const de_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Laden ist etwas schiefgegangen. Das liegt an uns, nicht an dir.`)
};

const ru_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось это загрузить. Это наша вина, не ваша.`)
};

const it_catalog_error_default = /** @type {(inputs: Catalog_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto nel caricamento. È colpa nostra, non tua.`)
};

/**
* | output |
* | --- |
* | "Something went wrong loading this. It’s us, not you." |
*
* @param {Catalog_Error_DefaultInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const catalog_error_default = /** @type {((inputs?: Catalog_Error_DefaultInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Error_DefaultInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_catalog_error_default(inputs)
	if (locale === "pt-BR") return pt_br2_catalog_error_default(inputs)
	if (locale === "es") return es_catalog_error_default(inputs)
	if (locale === "fr") return fr_catalog_error_default(inputs)
	if (locale === "de") return de_catalog_error_default(inputs)
	if (locale === "ru") return ru_catalog_error_default(inputs)
	if (locale === "it") return it_catalog_error_default(inputs)
	return en_catalog_error_default(inputs)
});